import { useState ,useRef} from "react";
import { useNavigate } from "react-router";
import apiConvocatorias from "../api/Convocatorias/api-convocatorias";
import { openNotification } from "../utils/saveFile";
import  DocumentosService  from "../api/Documentos/api-documentos";
import {
  LineaConvocatoria,
} from "../models/ConvocatoriasModel/convocatoria.model";
import apiMaestras from "../api/Maestras/api-maestras";
import { useEncrypt } from "./useEncrypt";
import getStorageUser from "../middlewares/GetStorageUser"

export const useInfoConvocatoria = () => {
  const { decrypt, encrypt } = useEncrypt();

  const idConvocatoria = decrypt(localStorage.getItem("id_convocatoria"));

  const editar_convocatoria = decrypt(
    localStorage.getItem("editar_convocatoria")
  );

  const [loading, setLoading] = useState(false);

  let editarConvocatoria = false;

  if (editar_convocatoria !== null) {
    editarConvocatoria = Boolean(editar_convocatoria);
  }

  const navigate = useNavigate();

  const initialState = {
    nombre_convocatoria: "",
    linea_convocatoria: null,
    categoria_linea_convocatoria: [],
    entidad: "SCC",
    tipo_participante: [],
    menor_edad: false,
    pseudonimo: false,
    ciclo: null,
    linea_estrategica: null,
    area: [],
    cobertura: null,
    esconvenio: false,
    tipo_estimulo: null,
    valor_total_entg: 0,
    bolsa_concursable: false,
    num_estimulos: 0,
    modalidad: null,
    descripcion_corta: "",
    objetivo: "",
    noparticipa: "",
    perfil_participante: "",
    portada_url:""
  };

  const participantes = [
    { id: 1, name: "Persona natural" },
    { id: 2, name: "Persona jurídica" },
    { id: 3, name: "Grupo conformado" },
  ];

  const [convocatoria, setConvocatoria] = useState(initialState);
  const [obligatorios, setObligatorios] = useState({
    nombre_convocatoria: false,
    linea_convocatoria: false,
    categoria_linea_convocatoria: false,
    tipo_participante: false,
    ciclo: false,
    linea_estrategica: false,
    area: false,
    cobertura: false,
    tipo_estimulo: false,
    descripcion_corta: false,
    objetivo: false,
    noparticipa: false,
    perfil_participante: false,
    portada_url: false,
  });

  const onFinish = async (values: any) => {
    setLoading(true);
    const user = getStorageUser()
    let categoriasConvocatoria = values.categoria_linea_convocatoria.map(
      (x: any) => {
        let filtrado: any = categoriasLC.filter(
          (data) => data.id === x || data.nombre === x
        );
        return {
          value: filtrado[0].id,
          text: filtrado[0].nombre,
        };
      }
    );
    let areas = values.area.map((x: any) => {
      return {
        value: x,
        text: x,
      };
    });
    let tipoParticipante = values.tipo_participante.map((x: any) => {
      let filtrado = participantes.filter((data) => data.id === x);
      return {
        value: filtrado[0].id,
        text: filtrado[0].name,
      };
    });

    values.categoria_linea_convocatoria = categoriasConvocatoria;
    values.area = areas;
    values.tipo_participante = tipoParticipante;
    values.usuario_creacion = `${user.nombres} ${user.apellidos}`;

    values = { ...values, tipo: 1 };

    if (editarConvocatoria) {
      await apiConvocatorias.editConvocatoria(
        idConvocatoria,
        values
      );
      await localStorage.setItem("editar_convocatoria", encrypt("true"));
    } else {
      const data = await apiConvocatorias.postConvocatoria(values);

      await localStorage.setItem("editar_convocatoria", encrypt("true"));
      await localStorage.setItem('id_convocatoria', encrypt(data.data.idconvocatorias.toString()));
    }

    setLoading(false);
    navigate("/administrador/cronogramaActividades");
  };
  const fileInputRef = useRef<any>();
  const [guardoArchivo, setGuardoArchivo] = useState(false);
  const [isBolsaConcursable, setIsBolsaConcursable] = useState(false);
  const [disabledForm, setDisabledForm] = useState(true);

  const handleChange = async (value: any, name: string) => {
    if (name === "esconvenio") {
      let infoupdate = { ...convocatoria };
      infoupdate[name] = value;
      return setConvocatoria(infoupdate);
    }
    if (name === "menor_edad") {
      let infoupdate = { ...convocatoria };
      infoupdate[name] = value;
      return setConvocatoria(infoupdate);
    }

    if (name === "modalidad") {
      let infoupdate = { ...convocatoria };
      infoupdate[name] = value;
      return setConvocatoria(infoupdate);
    }

    if (name == "nombre_convocatoria") {
      obligatorios[name] = true;
      setObligatorios({
        ...obligatorios,
        [name]: true,
      });
      let array = Object.values(obligatorios);
      if (array.filter((data) => data === false).length === 0) {
        setDisabledForm(false);
      }
    }

    if (name == "portada_url") {
      obligatorios[name] = true;
      setObligatorios({
        ...obligatorios,
        [name]: true,
      });
      let array = Object.values(obligatorios);
      if (array.filter((data) => data === false).length === 0) {
        setDisabledForm(false);
      }
    }

    if (name == "linea_convocatoria") {
      try {
        const { data } = await apiMaestras.obtenerCategoriasPorLinea(value);
        setCategoriasLC(data);
        setCategoriasDisabled(false);

        obligatorios[name] = true;
        setObligatorios({
          ...obligatorios,
          [name]: true,
        });
        let array = Object.values(obligatorios);
        if (array.filter((data) => data === false).length === 0) {
          setDisabledForm(false);
        }
      } catch (error) {
        console.log(error);
      }
      setObligatorios({
        ...obligatorios,
        [name]: true,
        categoria_linea_convocatoria: false,
      });
      return setConvocatoria({
        ...convocatoria,
        [name]: value,
        categoria_linea_convocatoria: [],
      });
    }

    if (name == "categoria_linea_convocatoria") {
      obligatorios[name] = true;
      setObligatorios({
        ...obligatorios,
        [name]: true,
      });
      let array = Object.values(obligatorios);
      if (array.filter((data) => data === false).length === 0) {
        setDisabledForm(false);
      }
    }
    if (name == "tipo_participante") {
      obligatorios[name] = true;
      setObligatorios({
        ...obligatorios,
        [name]: true,
      });
      let array = Object.values(obligatorios);
      if (array.filter((data) => data === false).length === 0) {
        setDisabledForm(false);
      }
    }
    if (name == "ciclo") {
      obligatorios[name] = true;
      setObligatorios({
        ...obligatorios,
        [name]: true,
      });
      let array = Object.values(obligatorios);
      if (array.filter((data) => data === false).length === 0) {
        setDisabledForm(false);
      }
    }

    if (name == "linea_estrategica") {
      obligatorios[name] = true;
      setObligatorios({
        ...obligatorios,
        [name]: true,
      });
      let array = Object.values(obligatorios);
      if (array.filter((data) => data === false).length === 0) {
        setDisabledForm(false);
      }
    }
    if (name == "area") {
      obligatorios[name] = true;
      setObligatorios({
        ...obligatorios,
        [name]: true,
      });
      let array = Object.values(obligatorios);
      if (array.filter((data) => data === false).length === 0) {
        setDisabledForm(false);
      }
    }
    if (name == "descripcion_corta") {
      obligatorios[name] = true;
      setObligatorios({
        ...obligatorios,
        [name]: true,
      });
      let array = Object.values(obligatorios);
      if (array.filter((data) => data === false).length === 0) {
        setDisabledForm(false);
      }
    }
    if (name == "objetivo") {
      obligatorios[name] = true;
      setObligatorios({
        ...obligatorios,
        [name]: true,
      });
      let array = Object.values(obligatorios);
      if (array.filter((data) => data === false).length === 0) {
        setDisabledForm(false);
      }
    }
    if (name == "noparticipa") {
      obligatorios[name] = true;
      setObligatorios({
        ...obligatorios,
        [name]: true,
      });
      let array = Object.values(obligatorios);
      if (array.filter((data) => data === false).length === 0) {
        setDisabledForm(false);
      }
    }
    if (name == "perfil_participante") {
      obligatorios[name] = true;
      setObligatorios({
        ...obligatorios,
        [name]: true,
      });
      let array = Object.values(obligatorios);
      if (array.filter((data) => data === false).length === 0) {
        setDisabledForm(false);
      }
    }

    if (name == "cobertura") {
      obligatorios[name] = true;
      setObligatorios({
        ...obligatorios,
        [name]: true,
      });
      let array = Object.values(obligatorios);
      if (array.filter((data) => data === false).length === 0) {
        setDisabledForm(false);
      }
    }

    if (name == "tipo_estimulo") {
      if (value == "Económico") {
        setIsEconomico(true);
      } else {
        setIsEconomico(false);
        setIsBolsaConcursable(false);
      }

      setObligatorios({
        ...obligatorios,
        [name]: true,
      });

      obligatorios[name] = true;
      setObligatorios({
        ...obligatorios,
        [name]: true,
      });

      if (value !== "Económico") {
        let infoupdate = { ...convocatoria };
        infoupdate.tipo_estimulo = value;
        infoupdate.valor_total_entg = 0;
        infoupdate.num_estimulos = 0;
        return setConvocatoria(infoupdate);
      }
    }

    if (name == "bolsa_concursable") {
      if (value) {
        setIsBolsaConcursable(true);
      } else {
        setIsBolsaConcursable(false);
      }
    }

    setConvocatoria({ ...convocatoria, [name]: value });
  };
  const [portada, setPortada] = useState<any>("");
  const [categoriasDisabled, setCategoriasDisabled] = useState(true);
  const [categoriasLC, setCategoriasLC] = useState<any[]>([]);
  const handleLineaConvocatoriaChange = async (value: number) => {
    try {
      const { data } = await apiMaestras.obtenerCategoriasPorLinea(value);
      setCategoriasLC(data);
    } catch (error) {
      console.log(error);
    }
    setCategoriasDisabled(false);
  };

  const [isEconomico, setIsEconomico] = useState(false);
  const handleTipoEstimuloChange = (value: string) => {
    if (value == "Económico") {
      setIsEconomico(true);
    } else {
      setIsEconomico(false);
    }
  };

  const [lineasConvocatoria, setLineasConvocatoria] = useState<
    LineaConvocatoria[]
  >([]);
  const getLineasConvocatoria = async () => {
    try {
      const { data } = await apiMaestras.obtenerLineaConvocatoria();
      setLineasConvocatoria(data);
    } catch (error) {
      console.log(error);
    }
  };

  const cargarConvocatoria = async () => {
    let { data } = await apiConvocatorias.getConvocatoriaById(idConvocatoria);
    let dataareas = data.area.map((data: any) => data.value);
    let datacategorias = data.categoria_linea_convocatoria.map(
      (data: any) => data.text
    );
    let datatipoparticipante = data.tipo_participante.map(
      (data: any) => data.value
    );
    setPortada(data.portada_url);
    data.area = dataareas;
    data.categoria_linea_convocatoria = datacategorias;
    data.tipo_participante = datatipoparticipante;
    handleLineaConvocatoriaChange(data.linea_convocatoria);
    setCategoriasDisabled(false);
    if (data.tipo_estimulo === "Económico") {
      setIsEconomico(true);
    }
    if (data.bolsa_concursable) setIsBolsaConcursable(true);
    setObligatorios({
      nombre_convocatoria: true,
      linea_convocatoria: true,
      categoria_linea_convocatoria: true,
      tipo_participante: true,
      ciclo: true,
      linea_estrategica: true,
      area: true,
      cobertura: true,
      tipo_estimulo: true,
      descripcion_corta: true,
      objetivo: true,
      noparticipa: true,
      perfil_participante: true,
      portada_url: true
    });
    setDisabledForm(false);
    return setConvocatoria(data);
  };

  const mascaraMiles = (input: any) => {
    var num = input.value.replace(/\./g, "");
    if (!isNaN(num)) {
      num = num
        .toString()
        .split("")
        .reverse()
        .join("")
        .replace(/(?=\d*\.?)(\d{3})/g, "$1.");
      num = num.split("").reverse().join("").replace(/^[\.]/, "");
    } else {
      alert("Solo se permiten numeros");
      input.value = input.value.replace(/[^\d\.]*/g, "");
    }
  };

  const guardarArchivo = async (e: any) => {
    if (e.target.files.length > 0) {
      if (e.target.files[0].size > 5000000) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos menores a 5MB",
          placement: "bottomRight",
        });
      }
      if (
        e.target.files[0].type === "image/png" ||
        e.target.files[0].type === "image/jpeg"
      ) {
        const formData = new FormData();
        formData.append("archivo", e.target.files[0]);
        const data = await DocumentosService.guardarArchivo(formData);
        return setPortada(data.data);
      }
      openNotification({
        titulo: "Error",
        descripcion: "Solo se permiten archivos Png y Jpg",
        placement: "bottomRight",
      });
      return setPortada("");
    }
  };

  return {
    onFinish,
    convocatoria,
    setConvocatoria,
    lineasConvocatoria,
    getLineasConvocatoria,
    handleLineaConvocatoriaChange,
    categoriasDisabled,
    categoriasLC,
    handleTipoEstimuloChange,
    isEconomico,
    handleChange,
    isBolsaConcursable,
    disabledForm,
    cargarConvocatoria,
    mascaraMiles,
    initialState,
    loading,
    setLoading,
    guardarArchivo,
    portada,
    setPortada,
    setGuardoArchivo,
    guardoArchivo,
    fileInputRef
  };
};
